import {SagaIterator} from "redux-saga";
import {all, takeLatest} from "redux-saga/effects";
import {
	getIsFriendlyCountry,
	requestContest,
	requestUser,
	saveUserAnswers,
	saveUnLoggedAnswers,
	requestProfile,
	saveProfile,
	requestLandingData,
	requestUserAnswers,
	editUserAnswers,
	fetchOverallRanking,
	requestHelpPages,
} from "modules/actions";
import {
	requestContestJsonSaga,
	getIsFriendlyCountrySaga,
	saveUserAnswersSaga,
	requestUserSaga,
	saveUnLoggedAnswersSaga,
	requestProfileSaga,
	saveProfileSaga,
	requestLandingDataSaga,
	requestUserAnswersSaga,
	editUserAnswersSaga,
	requestHelpPagesSaga,
} from "modules/sagas";
import {fetchOverallRankingSaga} from "modules/sagas/ranking";

/**
 * Root saga that connect sagas with actions.
 */
export const rootSaga = function* (): SagaIterator {
	yield all([
		/**
		 * JSON
		 */
		takeLatest(requestContest, requestContestJsonSaga),
		takeLatest(requestHelpPages, requestHelpPagesSaga),
		/**
		 * Game
		 */
		takeLatest(requestLandingData, requestLandingDataSaga),
		takeLatest(saveUserAnswers, saveUserAnswersSaga),
		takeLatest(editUserAnswers, editUserAnswersSaga),
		takeLatest(requestUserAnswers, requestUserAnswersSaga),
		takeLatest(getIsFriendlyCountry, getIsFriendlyCountrySaga),
		takeLatest(saveUnLoggedAnswers, saveUnLoggedAnswersSaga),
		/**
		 * User
		 */
		takeLatest(requestUser, requestUserSaga),
		/**
		 * Profile
		 */
		takeLatest(requestProfile, requestProfileSaga),
		takeLatest(saveProfile, saveProfileSaga),
		/**
		 * Ranking
		 */
		takeLatest(fetchOverallRanking, fetchOverallRankingSaga),
	]);
};

export * from "./json";
export * from "./user";
export * from "./game";
